import { render, staticRenderFns } from "./BundlesListProductPage.vue?vue&type=template&id=000f2192"
import script from "./BundlesListProductPage.vue?vue&type=script&lang=js"
export * from "./BundlesListProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports